module.exports = __webpack_public_path__ + "img/1.08.thmb.58ee5f80.jpg";